import { useEffect } from "react";

const focusableSelector = [
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[role='combobox']:not([aria-disabled='true'])",
].join(",");

const ignoresArrowNavigation = (target) => (
  target.matches("select, textarea, [data-arrow-navigation-ignore]")
  || target.closest("[role='listbox']")
);

export const useFormArrowNavigation = () => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) {
        return;
      }
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
        return;
      }
      if (!(event.target instanceof HTMLElement) || ignoresArrowNavigation(event.target)) {
        return;
      }

      const form = event.target.closest(
        "form, [data-form-navigation], .data-panel, .page-enter",
      );
      if (!form) {
        return;
      }

      const fields = [...form.querySelectorAll(focusableSelector)].filter((field) => (
        field.offsetParent !== null
        && !field.hasAttribute("readonly")
        && !field.dataset.testid?.endsWith("-combobox-clear-button")
      ));
      const currentIndex = fields.indexOf(event.target);
      const destinationIndex = currentIndex + (event.key === "ArrowDown" ? 1 : -1);
      const destination = fields[destinationIndex];
      if (!destination) {
        return;
      }

      event.preventDefault();
      destination.focus({ preventScroll: false });
      if (destination instanceof HTMLInputElement && destination.type === "text") {
        destination.select();
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, []);
};